import ExclamationCircleOutlined from '@ant-design/icons/ExclamationCircleOutlined';
import Button from 'antd/lib/button';
import Modal from 'antd/lib/modal';
import { IMarketAward, MarketAwardStatus } from 'src/domain/caiso/cmri/interface';
import { currencyUSDFormatter } from 'src/domain/common/currencyFormatters';
import { formatInTimeZone } from 'date-fns-tz';
import { CAISO_TZ } from 'src/domain/caiso';
import { useCaisoMarketAwardsDeny } from 'src/domain/caiso/cmri/queries';
import './MarketAwardsDenyModal.css';

interface IMarketAwardsDenyModalProps {
    awards: IMarketAward[];
    onClose?: (actionTaken: boolean) => void;
}

export const MarketAwardsDenyModal = (props: IMarketAwardsDenyModalProps) => {
    const validMarketAwards = props.awards.filter(award => award.status === MarketAwardStatus.NEW);
    const onClose = props.onClose ? props.onClose : (actionTaken: boolean) => {};

    const caisoMarketAwardsDeny = useCaisoMarketAwardsDeny();

    const title =
        validMarketAwards.length > 1 ? `You are going to deny ${validMarketAwards.length} Market Awards.` : `You are going to deny 1 Market Award.`;

    async function onConfirm() {
        await caisoMarketAwardsDeny.mutateAsync({ ids: validMarketAwards.map(item => item.id) });
        onClose(true);
    }

    return (
        <Modal
            open
            destroyOnHidden
            className="market-awards-deny-modal"
            title={
                <div style={{ display: 'flex' }}>
                    <ExclamationCircleOutlined style={{ color: 'orange', fontSize: '24px' }} /> &nbsp; {title}
                </div>
            }
            onCancel={() => onClose(false)}
            width="450px"
            footer={[
                <Button key="market-awards-deny-modal-close" onClick={() => onClose(false)}>
                    Close
                </Button>,
                <Button key="market-awards-deny-modal-confirm" danger type="primary" onClick={onConfirm} loading={caisoMarketAwardsDeny.isLoading}>
                    Confirm
                </Button>,
            ]}
        >
            {validMarketAwards.map((award, index) => (
                <div key={`award-${index}`} className="market-award-block">
                    <div className="market-award-block-item">
                        <div>Resource:</div>
                        <div>{award.resourceName}</div>
                    </div>
                    <div className="market-award-block-item">
                        <div>Starts at:</div>
                        <div>
                            {formatInTimeZone(award.start, CAISO_TZ, 'dd-MMM-yyyy HH:mm aaa')} - {formatInTimeZone(award.end, CAISO_TZ, 'HH:mm aaa')}
                        </div>
                    </div>
                    <div className="market-award-block-item">
                        <div>LMP:</div>
                        <div>{award.price == null ? '-' : currencyUSDFormatter.format(award.price)}</div>
                    </div>
                    <div className="market-award-block-item">
                        <div>Earnings:</div>
                        <div>{award.earnings == null ? '-' : currencyUSDFormatter.format(award.earnings)}</div>
                    </div>
                </div>
            ))}
        </Modal>
    );
};
